export class SelectedFixedLinksDto {
  public desmosCalculator: boolean = true;
  public desmosScientific: boolean = true;
  public desmosFourFunction: boolean = true;
  public desmosGeometry: boolean = true;

  constructor(data: any) {
    if (data) {
      this.desmosCalculator = data.desmosCalculator ?? true;
      this.desmosScientific = data.desmosScientific ?? true;
      this.desmosFourFunction = data.desmosFourFunction ?? true;
      this.desmosGeometry = data.desmosGeometry ?? true;
    }
  }
}